<template>
  <v-dialog
    :model-value="modelValue"
    max-width="720"
    persistent
    scrollable
    @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="text-primary weight-600 text-wrap">
        Please answer the following questions before sending to plan.
      </v-card-title>
      <v-card-text class="cmm-popup-answers-content">
        <div v-for="q in questions" :key="q.id" class="cmm-popup-question-block mb-4">
          <p class="text-body-2 mb-2" style="white-space: normal; word-break: normal">
            {{ q.question }}
          </p>
          <v-radio-group v-model="localAnswers[q.id]" density="compact" class="mt-0" hide-details inline>
            <v-radio label="Yes" value="Yes" />
            <v-radio label="No" value="No" />
          </v-radio-group>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="outlined" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" variant="flat" :disabled="!allFilled" @click="confirm">Continue</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, computed } from "vue";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  questions: { type: Array, default: () => [] },
  initialAnswers: { type: Object, default: () => ({}) },
});

const emit = defineEmits(["update:modelValue", "confirm"]);

const localAnswers = ref({});

watch(
  () => [props.modelValue, props.questions, props.initialAnswers],
  () => {
    if (props.modelValue && props.questions?.length) {
      const byId = {};
      props.questions.forEach((q) => {
        if (q?.id != null) {
          const v = props.initialAnswers[q.id];
          if (v === "Yes" || v === "No") byId[q.id] = v;
        }
      });
      localAnswers.value = byId;
    }
  },
  { immediate: true }
);

const allFilled = computed(() => {
  const qs = props.questions ?? [];
  if (!qs.length) return false;
  return qs.every((q) => {
    if (!q || typeof q.id !== "string") return false;
    const v = localAnswers.value[q.id];
    return v === "Yes" || v === "No";
  });
});

function cancel() {
  emit("update:modelValue", false);
}

function confirm() {
  const answers = {};
  (props.questions ?? []).forEach((q) => {
    if (q && typeof q.id === "string") {
      const v = localAnswers.value[q.id];
      if (v === "Yes" || v === "No") answers[q.id] = v;
    }
  });
  emit("confirm", answers);
  emit("update:modelValue", false);
}
</script>

<style lang="scss" scoped>
.cmm-popup-answers-content {
  max-height: 70vh;
  overflow-y: auto;
}
.cmm-popup-question-block p {
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}
</style>
